import type { ReactNode } from "react";
import { ShortcutKbd } from "@volca/ui/components/ui/shortcut-kbd";
import { Stack } from "@volca/ui/components/ui/stack";
import type { ShortcutKey } from "@volca/ui/lib/desktop-platform";

export const TooltipShortcut = ({
  keys,
  children,
}: {
  keys: readonly ShortcutKey[];
  children: ReactNode;
}) => (
  <Stack direction="row" gap={2} align="center">
    {children}
    <ShortcutKbd keys={keys} />
  </Stack>
);
